/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  SupportShopState,
  SupportShopDetailData,
  SupportShopPutData
} from '@/types/master/supportShop';
import _ from 'lodash';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    detailData: null,
    putData: null
  },
  mutations: {
    setDetail(state: SupportShopState, payload: SupportShopDetailData) {
      state.detailData = payload;
    },
    setPut(state: SupportShopState, payload: SupportShopPutData) {
      state.putData = payload;
    }
  },
  actions: {
    async fetch(context: any, supportShopMasterId: any) {
      await axios
        .get(getBaseUrl() + '/master/support-shops/' + supportShopMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setDetail', response.data);
          const setData = _.cloneDeep(response.data);
          context.commit('setPut', setData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'サポート店情報が存在しません。');
            return router.push('/master/supportshop');
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/master/supportshop');
          } else {
            router.push('/error/server');
          }
        });
    },
    async delete(context: any, supportShopMasterId: string) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .delete(getBaseUrl() + '/master/support-shops/' + supportShopMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('success', 'サポート店情報の削除に成功しました。');

          router.push('/master/supportshop');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'サポート店情報が存在しません。');

            return router.push('/master/supportshop');
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    },
    async put(context: any, payload: SupportShopPutData) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .put(
          getBaseUrl() + '/master/support-shops/' + payload.id,
          {
            name: payload.name,
            affiliationUnion: payload.affiliationUnion,
            zip: payload.zip,
            prefecture: payload.prefecture,
            city: payload.city,
            address: payload.address,
            addressSub: payload.addressSub,
            tel: payload.tel,
            mobileNumber: payload.mobileNumber,
            staffName: payload.staffName
          },
          {
            headers: { auth: await getAccessToken() }
          }
        )
        .then(() => {
          success('Success', 'サポート店情報の変更に成功しました。');
          router.push('/master/supportshop');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, 'サポート店情報が存在しません。');
            router.push('/master/supportshop');
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
